'use es6';

import { getBusinessUnitId } from 'FormsUI/selectors/FormDefinition';
import { getSelectedBusinessUnitId } from 'FormsUI/selectors/FormCreation';
import { isBusinessUnitId } from 'FormsCommonComponents/utils/BusinessUnitsUtils';
import { ACCOUNT_BUSINESS_UNIT_ID } from 'FormsCommonComponents/constants/BusinessUnits';
export function getCurrentFormBusinessUnitId(state) {
  const businessUnitId = getBusinessUnitId(state);
  const selectedBusinessUnitId = getSelectedBusinessUnitId(state);
  if (isBusinessUnitId(businessUnitId)) {
    return businessUnitId;
  } else if (isBusinessUnitId(selectedBusinessUnitId)) {
    return selectedBusinessUnitId;
  } else {
    return ACCOUNT_BUSINESS_UNIT_ID;
  }
}